import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment-timezone'

export function useTimeDifference(date: Date | string | undefined): string | null {
    const { t } = useTranslation()
    const [difference, setDifference] = useState<string | null>(null)

    useEffect(() => {
        if (!date) {
            setDifference(null)
            return
        }

        const now: Date = new Date()
        const timePost: Date = typeof date === 'string' ? moment(date, 'DD-MM-YYYY HH:mm:ss').utc(true).toDate() : date

        const timeDiff: number = now.getTime() - timePost.getTime()
        const daysDiff: number = Math.floor(timeDiff / (1000 * 60 * 60 * 24))

        if (daysDiff > 0) {
            setDifference(
                `${t('thereIs')} ${daysDiff} ${daysDiff > 1 ? t('days').toLowerCase() : t('day').toLowerCase()}`
            )
        } else {
            const hoursDiff: number = Math.floor(timeDiff / (1000 * 60 * 60))

            if (hoursDiff > 0) {
                setDifference(
                    `${t('thereIs')} ${hoursDiff} ${hoursDiff > 1 ? t('hours').toLowerCase() : t('hour').toLowerCase()}`
                )
            } else {
                const minutesDiff: number = Math.floor(timeDiff / (1000 * 60))
                setDifference(
                    `${t('thereIs')} ${minutesDiff} ${minutesDiff > 1 ? t('minutes').toLowerCase() : t('minute').toLowerCase()}`
                )
            }
        }
    }, [date, t])

    return difference
}
